import { createRouter, createWebHistory } from 'vue-router'
import en from '@/language/en.js'
import zh from '@/language/zh'

const Layout = () => import('@/layout/index.vue')

export const constantRoutes = [
  // 首页
  {
    path: '/',
    component: Layout,
    redirect: '/home',
    hidden: false, // 设置路由是否在侧边栏出现
    children: [
      {
        path: '/home',
        name: 'Home',
        component: () => import('@/views/home/index.vue'),
        meta: {
          title: zh.homeRoute.title, // 中文标题
          enTitle: en.homeRoute.title, // 英文标题
          icon: 'shouye-weixuan', // 侧边栏 菜单展示的图标
          affix: false, // 是否固定在标签栏
          breadcrumb: true, // 是否在面包屑中展示
          keepAlive: true // 是否缓存页面
        }
      }
    ]
  },
  // 订单管理
  {
    path: '/orders',
    component: Layout,
    redirect: '/orders/order-center',
    alwaysShow: false,
    name: 'Orders',
    meta: {
      title: zh.orderRoute.orders,
      enTitle: en.orderRoute.orders,
      icon: 'WarehouseInformation-weixuanzhong'
    },
    children: [
      {
        path: '/orders/order-center',
        name: 'order-center',
        component: () => import('@/views/orders/order-center/index.vue'),
        meta: { title: zh.orderRoute.myOrders, enTitle: en.orderRoute.myOrders }
      },
      {
        path: '/orders/update-declare-value',
        name: 'update-declare-value',
        hidden: true,
        component: () => import('@/views/orders/update-declared-value/index.vue'),
        meta: { title: zh.OrderCenter.edit_btn, enTitle: en.OrderCenter.edit_btn }
      },
      {
        path: '/orders/order-detail',
        name: 'order-detail',
        hidden: true,
        component: () => import('@/views/orders/order-detail/index.vue'),
        meta: { title: zh.orderRoute.orderDetail, enTitle: en.orderRoute.orderDetail }
      },
      {
        path: '/orders/import-order',
        name: 'importOrder',
        component: () => import('@/views/orders/import-order/index.vue'),
        meta: { title: zh.orderRoute.importOrder, enTitle: en.orderRoute.importOrder }
      },
      {
        path: '/orders/create-order',
        name: 'create-order',
        component: () => import('@/views/orders/create-order/index.vue'),
        meta: {
          title: zh.orderRoute.createOrder,
          enTitle: en.orderRoute.createOrder,
          isC: true,
          customerType: 3
        }
      },
      {
        path: '/orders/receiver-tax-unpaid',
        name: 'receiver-tax-unpaid',
        component: () => import('@/views/orders/receiver-tax-unpaid/index.vue'),
        meta: {
          title: zh.orderRoute.receiverTaxUnpaid,
          enTitle: en.orderRoute.receiverTaxUnpaid
        }
      },
      {
        path: '/orders/sender-tax-unpaid',
        name: 'sender-tax-unpaid',
        component: () => import('@/views/orders/sender-tax-unpaid/index.vue'),
        meta: {
          title: zh.orderRoute.senderTaxUnpaid,
          enTitle: en.orderRoute.senderTaxUnpaid
        }
      },
      {
        path: '/orders/price-list',
        name: 'price-list',
        component: () => import('@/views/orders/price-list/index.vue'),
        meta: {
          title: zh.orderRoute.priceList,
          enTitle: en.orderRoute.priceList,
          isC: true
        }
      },
      {
        path: '/orders/remote-area-orders',
        name: 'remote-area-orders',
        component: () => import('@/views/orders/remote-area-orders/index.vue'),
        meta: {
          title: zh.orderRoute.remoteAreaOrders,
          enTitle: en.orderRoute.remoteAreaOrders
        }
      }
    ]
  },
  // 财务管理
  {
    path: '/finacial-stats',
    component: Layout,
    redirect: '/finacial-stats/cost-stats',
    alwaysShow: false,
    name: 'FinacialStats',
    meta: {
      title: zh.finacialRoute.finacialStats,
      enTitle: en.finacialRoute.finacialStats,
      icon: 'Payment-weixuanzhong-d0h2gf68'
    },
    children: [
      {
        path: '/finacial-stats/incoming-expense',
        name: 'incoming-expense',
        component: () => import('@/views/finacial-stats/incoming-expense/index.vue'),
        meta: {
          title: zh.finacialRoute.incomingoutgoings,
          enTitle: en.finacialRoute.incomingoutgoings,
          customerType: 3
        }
      },
      {
        path: '/finacial-stats/cost-stats',
        name: 'cost-stats',
        component: () => import('@/views/finacial-stats/cost-stats/index.vue'),
        meta: {
          title: zh.finacialRoute.freightstatistics,
          enTitle: en.finacialRoute.freightstatistics
        }
      },
      {
        path: '/finacial-stats/customer-bill',
        name: 'customer-bill',
        component: () => import('@/views/finacial-stats/customer-bill/index.vue'),
        meta: { title: zh.finacialRoute.bill, enTitle: en.finacialRoute.bill, isB: true }
      },
      {
        path: '/finacial-stats/customer-bill-detail',
        name: 'customer-bill-detail',
        hidden: true,
        component: () => import('@/views/finacial-stats/customer-bill-detail/index.vue'),
        meta: { title: zh.finacialRoute.billDetail, enTitle: en.finacialRoute.billDetail }
      }
    ]
  },
  {
    path: '/personal-info',
    component: Layout,
    redirect: '/personal-info/my-profile',
    alwaysShow: false,
    name: 'PersonalInfo',
    meta: {
      title: zh.userRoute.personal,
      enTitle: en.userRoute.personal,
      icon: 'icon-zhanghuxinxishezhi-weixuanzhong'
    },
    children: [
      {
        path: '/personal-info/my-profile',
        name: 'my-profile',
        component: () => import('@/views/personal-info/my-profile/index.vue'),
        meta: { title: zh.userRoute.myProfile, enTitle: en.userRoute.myProfile }
      },
      {
        path: '/personal-info/change-pwd',
        name: 'change-pwd',
        component: () => import('@/views/personal-info/change-pwd/index.vue'),
        meta: { title: zh.userRoute.changePwd, enTitle: en.userRoute.changePwd }
      },
      {
        path: '/personal-info/recharge',
        name: 'recharge',
        component: () => import('@/views/personal-info/recharge/index.vue'),
        meta: { title: zh.userRoute.recharge, enTitle: en.userRoute.recharge }
      }
    ]
  },
  // 发票管理
  {
    path: '/invoice-management',
    component: Layout,
    redirect: '/invoice-management/invoice-information',
    alwaysShow: false,
    name: 'invoice-information',
    meta: {
      title: zh.invoiceRoute.invoiceManagement,
      enTitle: en.invoiceRoute.invoiceManagement,
      icon: 'fapiaoguanli-weixuan'
    },
    children: [
      {
        path: '/invoice-management/invoice-information',
        name: 'invoice-information',
        component: () => import('@/views/invoice-management/invoice-information/index.vue'),
        meta: {
          title: zh.invoiceRoute.invoiceInformationManagement,
          enTitle: en.invoiceRoute.invoiceInformationManagement
        }
      },
      {
        path: '/invoice-management/invoice-request',
        name: 'invoice-request',
        component: () => import('@/views/invoice-management/invoice-request/index.vue'),
        meta: { title: zh.invoiceRoute.invoiceRequest, enTitle: en.invoiceRoute.invoiceRequest }
      },
      {
        path: '/invoice-management/invoice-list',
        name: 'invoice-list',
        component: () => import('@/views/invoice-management/list-of-invoices/index.vue'),
        meta: { title: zh.invoiceRoute.invoiceList, enTitle: en.invoiceRoute.invoiceList }
      }
    ]
  },
  {
    path: '/login',
    component: () => import('@/views/login/index.vue'),
    hidden: true
  },
  {
    path: '/404',
    component: () => import('@/views/404.vue'),
    hidden: true
  },
  // 404 page must be placed at the end !!!
  { path: '/:pathMatch(.*)*', redirect: '/404', hidden: true }
]

const router = createRouter({
  history: createWebHistory('/client'),
  routes: constantRoutes,
  scrollBehavior: () => ({ left: 0, top: 0 })
})

// 重置路由
export function resetRouter() {
  router.replace({ path: '/login' })
}

export default router
